"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SettingsOutlined_1 = __importDefault(require("@material-ui/icons/SettingsOutlined"));
var __1 = require("../../../..");
var props_1 = require("../../../context/props");
var ColumnsSettingButton = function (props) {
    var onClick = props.onClick;
    var translate = (0, props_1.usePropsContext)().translate;
    return (react_1.default.createElement(__1.Tooltip, { title: translate('dataGrid.columnSettings', 'Column settings') },
        react_1.default.createElement(SettingsOutlined_1.default, { color: "secondary", onClick: onClick })));
};
exports.default = ColumnsSettingButton;
